module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-08.9cfc3eec.png";